import { User } from '@nextroll/ar-base-api';
import { RuleValidationResult, RollWorksListType, RWListRules, useListBuilderComponents } from '@nextroll/ar-rollworks-list-builder';

interface IProps {
    advertisableEid?: string;
    user?: User;
    rules?: RWListRules;
    validationResult?: RuleValidationResult;
    onUpdate?: (rule: RWListRules | null, areRulesValid: boolean) => void;
    ready?: boolean;
}

export const TriggerListBuilderSection = (props: IProps) => {
    const {
        banners,
        builder,
        preview,
        btnPreview,
        isLoading,
        isValid,
        results,
    } = useListBuilderComponents({
        rollWorksListType: RollWorksListType.CONTACT,
        advertisableEid: props.advertisableEid || '',
        user: props.user,
        rules: props.rules,
        validationResult: props.validationResult,
        onUpdate: props.onUpdate,
    });

    return {
        banners,
        builder,
        preview,
        btnPreview,
        isLoading,
        isValid,
        results,
    };
};
